import { render, staticRenderFns } from "./CardTabItem.vue?vue&type=template&id=2f960c8e&"
import script from "./CardTabItem.vue?vue&type=script&lang=js&"
export * from "./CardTabItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f960c8e')) {
      api.createRecord('2f960c8e', component.options)
    } else {
      api.reload('2f960c8e', component.options)
    }
    module.hot.accept("./CardTabItem.vue?vue&type=template&id=2f960c8e&", function () {
      api.rerender('2f960c8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/card-tab/CardTabItem.vue"
export default component.exports